import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
const STILLNESS_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/1ae874a0-f2a4-41de-ac22-0ca0051d91ee.jpg';
const BOOKING_URL = 'https://fitculturepilates.com/locations/san-pedro-hot-room/#schedule';
type ClassEntry = {
  day: string;
  name: string;
  style: string;
  time: string;
};
const CLASSES: ClassEntry[] = [{
  day: 'Wednesday',
  name: 'Matcha Power',
  style: 'Infrared Power Yoga',
  time: '7:30 AM'
}, {
  day: 'Wednesday',
  name: 'Ginger Flow',
  style: 'Infrared Yoga Flow',
  time: '9:00 AM'
}];
export function Schedule() {
  return <section id="schedule" className="w-full bg-shell" data-id="element-141" data-mp="dea3dut2z3q1">
      <div className="relative h-40 w-full overflow-hidden md:h-56" data-id="element-142" data-mp="1jtuj7mrbgkda">
        <img src={STILLNESS_IMAGE} alt="Calm shallow seafoam water rippling in soft morning light" className="h-full w-full object-cover" data-id="element-143" data-mp="1jvoue9cscy46" />
      </div>

      <div className="mx-auto max-w-3xl px-6 py-24 md:px-10 md:py-32" data-id="element-144" data-mp="1d38gb4fwrdrv">
        <Reveal data-id="element-145" data-mp="1868bsxypij2v">
          <SectionLabel data-id="element-146" data-mp="185gijtsl0xfr">Weekly Flow</SectionLabel>
        </Reveal>
        <Reveal delay={0.08} data-id="element-147" data-mp="142k2oauffffi">
          <h2 className="mt-7 text-center font-display text-4xl font-light text-ink sm:text-5xl" data-id="element-148" data-mp="141s9t7s7rvsx">
            Class Schedule
          </h2>
        </Reveal>

        <ul className="mt-14" data-id="element-149" data-mp="u5p8g456s171">
          {CLASSES.map((item, i) => <Reveal as="li" key={`${item.day}-${item.name}-${item.time}`} delay={0.04 * i} data-id="element-150" data-mp="u706rofv4gqr" data-mpi={i}>
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="group flex flex-wrap items-baseline gap-x-6 gap-y-1 border-t border-clay/15 py-6 transition-colors duration-500 last:border-b hover:bg-cream" data-id="element-151" data-mp="pcma7ipgs3ki">
                <span className="w-24 shrink-0 text-[10px] font-light uppercase tracking-wider2 text-clay" data-id="element-152" data-mp="6fl0jkkytfa8">
                  {item.day}
                </span>

                <span className="flex flex-wrap items-baseline gap-x-4 gap-y-1" data-id="element-153" data-mp="3svs8o4ne5m14">
                  <span className="font-display text-xl font-light leading-snug text-ink" data-id="element-154" data-mp="1rtqqozvl1of">
                    {item.name}
                  </span>
                  <span className="text-[11px] font-light tracking-wide text-muted" data-id="element-155" data-mp="3nya6cx3vq523">
                    {item.style}
                  </span>
                </span>

                <span className="ml-auto flex items-center gap-3 text-[12px] font-light tracking-wider2 text-muted transition-colors duration-500 group-hover:text-clay" data-id="element-156" data-mp="fiyua26d6e41">
                  {item.time}
                  <ArrowUpRightIcon className="h-3.5 w-3.5 shrink-0 text-muted/60 transition-all duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-clay" strokeWidth={1.25} aria-hidden="true" data-id="element-157" data-mp="5s44woxtmyed" />
                </span>
              </a>
            </Reveal>)}
        </ul>

        <Reveal delay={0.2} data-id="element-158" data-mp="2nwvklkk86y0r">
          <p className="mt-12 border-t border-clay/15 pt-10 text-center text-[13px] font-light leading-relaxed text-muted" data-id="element-159" data-mp="2nw3o87it0w9f">
            All classes are held in the infrared hot room at Fit Culture, San Pedro. Select a class
            to reserve your spot. Mats and props are provided, and arriving ten minutes early is the
            kindest thing you can do for yourself.
          </p>
        </Reveal>
      </div>
    </section>;
}